import React, { createRef, Component } from "react";
import throttle from "lodash/throttle";
import { InView } from "react-intersection-observer";
import "styled-components/macro";

import guessMyDevice from "./utils/guess-my-device";

export default class StickyVideoFeatureTriad extends Component {
  state = {
    isVisibleVideo: false,
    isVisibleText: false,
    // Example
    // 0 ↔️ 0%
    // 20 ↔️ 20%
    // 44 ↔️ 44%
    // 100 ↔️ 100%
    videoPlaybackProgress: 0,
  };
  refVideo = createRef();
  refText = createRef();
  eventListener1 = null;

  device = guessMyDevice()

  render() {

    const {
      videoSrc,
      title,
      description,
      vizThreshold,
      desktopWidth,
      desktopPaddingX,
    } = this.props;
    const { isVisibleVideo, isVisibleText, videoPlaybackProgress } = this.state;

    return (
      <div
        css={`
          margin: 80px auto;
          padding: 0 ${desktopPaddingX}px;
          width: ${desktopWidth}px;
          /* Calc for 16:7.5 aspect ratio */
          /* height: ${(desktopWidth * 7.5) / 16}px;  */
        `}
      >
        {/* Video Embed */}
        <InView
          as="div"
          threshold={vizThreshold}
          onChange={this.handleVizVideo}
        >
          <div
            css={`
              border: 1px solid hsl(240 8% 87% / 1);
              border-radius: 22px;
            `}
          >
            <div
              css={`
                padding: 10px;
                background: hsl(240 8% 92% / 1);
                box-shadow: 0px 4px 19px 0px hsla(0, 0%, 0%, 0.03);
                border-radius: 22px;
                overflow: hidden;
                filter: ${isVisibleVideo
                  ? "contrast(1) opacity(1) saturate(1)"
                  : "contrast(0.9) opacity(0.6) saturate(0.35)"};
                transition: filter 250ms ease-out;
              `}
            >
              {/* Mock browser buttons */}
              <div>
                <div
                  css={`
                    display: flex;
                    margin: 5px 5px 10px;
                    opacity: 0.6;
                  `}
                >
                  <div
                    css={`
                      display: inline-block;
                      margin-right: 4px;
                      width: 13px;
                      height: 13px;
                      border-radius: 13px;
                      background-color: #4d00b2;
                    `}
                  />
                  <div
                    css={`
                      display: inline-block;
                      margin-right: 4px;
                      width: 13px;
                      height: 13px;
                      border-radius: 13px;
                      background-color: #4d17b2;
                    `}
                  />
                  <div
                    css={`
                      display: inline-block;
                      margin-right: 4px;
                      width: 13px;
                      height: 13px;
                      border-radius: 13px;
                      background-color: #0000b2;
                    `}
                  />
                </div>
              </div>
              {/* Video wrapper */}
              <div
                css={`
                  background-color: #ffffff;
                  padding: 0px 0px 0px 1px;
                  height: ${this.device === 'desktop' ? '563px' : this.device === 'mobile' ? '323.164px' : this.device === 'tablet' ? '323.164px' : 'auto'};
                  border-radius: 13px;
                  overflow: hidden;
                `}
              >
                <video
                  ref={this.refVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="auto"
                  width="100%"
                  src={videoSrc}
                  css={`
                    border-radius: 13px;
                    overflow: hidden;
                  `}
                />
              </div>
            </div>
          </div>
        </InView>

        {/* Copywriting and
        progress bar */}
        <InView as="div" threshold={1} onChange={this.handleVizText}>
          <div
            ref={this.refText}
            css={`
              display: flex;
              justify-content: space-between;
              margin: 20px 0 0 20px;
              filter: ${isVisibleVideo ? "opacity(1)" : "opacity(0.4)"};
              transition: filter 250ms ease-out, opacity 250ms ease-out;
            `}
          >
            {/* Copywriting */}
            <div
              css={`
                margin: 9px 15px 0;
              `}
            >
              <div
                css={`
                  font-weight: bolder;
                  font-size: 21px;
                  color: hsl(240 10% 35% / 1);
                `}
              >
                {title}
              </div>
              <div
                css={`
                  margin: 5px 0 0;
                  font-size: 18px;
                  font-weight: 500;
                  color: hsl(240 10% 60% / 1);
                  -webkit-font-smoothing: antialiased;
                  -moz-osx-font-smoothing: grayscale;
                `}
              >
                {description}
              </div>
            </div>
            {/* Video playback
            progress bar */}
            <div
              css={`
                position: relative;
                display: inline-block;
                width: 170px;
                height: 1px;
                background-color: #c6c7ec;
                overflow: hidden;
              `}
            >
              <div
                css={`
                  position: absolute;
                  display: inline-block;
                  width: 170px;
                  height: 1px;
                  background-color: #363bff;
                  transform: translateX(${-100 + videoPlaybackProgress}%);
                  filter: saturate(${isVisibleText ? 1 : 0.3});
                  transition: transform 1000ms linear, filter 250ms ease-out;
                `}
              ></div>
            </div>
          </div>
        </InView>
      </div>
    );
  }

  componentDidMount() {
    // Add listener to update
    // video playback time
    this.eventListener1 = this.refVideo.current.addEventListener(
      "timeupdate",
      this.handleTimeUpdate
    );
  }

  componentWillUnmount() {
    const domVideo = this.refVideo.current;

    this.eventListener1 = domVideo.removeEventListener(
      "timeupdate",
      this.eventListener1
    );
  }

  // Update the playback status, but
  // make sure to throttle it :P
  handleTimeUpdate = throttle(() => {
    const domVideo = this.refVideo.current;
    this.setState({
      videoPlaybackProgress: (domVideo.currentTime / domVideo.duration) * 100,
    });
  }, 500);

  handleVizVideo = (isVisibleVideo) => {
    if (isVisibleVideo)
    {
      // Reset video playback time
      // this.refVideo.current.currentTime = 0;
      // Play video
      this.playVideo();
    } else if (!isVisibleVideo)
    {
      this.pauseVideo()
    }
    this.setState({ isVisibleVideo: isVisibleVideo });
  };

  playVideo = () => {
    this.refVideo.current.play();
  }

  pauseVideo = () => {
    this.refVideo.current.pause();
  }
  handleVizText = (isVisibleText) => {
    this.setState({ isVisibleText: isVisibleText });
  };
}
